const shared = {
    appStore: 'App Store',
    googlePlay: 'Google Play',
};

export const refresh = {
    en: {
        ...shared,
        metaTitle: 'APC Plus — Shop, Earn, Send & Manage Credits',
        metaDescription:
            'Shop gift cards and vouchers, buy eSIMs, book hotels and flights, earn cashback, send Red Packets, and manage Credits with APC Plus.',
        navLive: 'Web app',
        navRoadmap: 'Roadmap',
        navMobile: 'Mobile',
        navFuture: 'What’s next',
        navStart: 'Get started',
        eyebrow: 'Live now · Web app',
        titleLead: 'Your credits, ',
        titleAccent: 'ready for more.',
        heroCopy: 'Shop, earn, send, and manage your Credits—all in one place.',
        seeNext: 'See what’s next',
        heroNoteLink: 'Sign in to APC Plus.',
        previewLabel: 'Illustration of the APC Plus Credits experience',
        previewTag: 'Your Credits, your way',
        previewActions: 'Shop. Earn. Send. Manage.',
        shop: 'Shop',
        earn: 'Earn',
        send: 'Send',
        manage: 'Manage',
        previewFoot: 'One account. More ways to use your Credits.',
        liveKicker: 'The Credits ecosystem',
        liveTitle: 'Credits for the things people do every day.',
        liveLead:
            'Shop gift cards and vouchers, get connected with eSIMs, book hotels and flights, earn cashback, and send Red Packets.',
        utilTitle: 'Everyday utility',
        utilText: 'Buy gift cards, vouchers, and eSIMs.',
        travelTitle: 'Travel',
        travelText: 'Book hotels and flights with Credits.',
        rewardsTitle: 'Rewards',
        rewardsText: 'Receive cashback on eligible purchases.',
        socialTitle: 'Social gifting',
        socialText: 'Send Red Packets to friends and family.',
        controlTitle: 'Flexible control',
        controlText: 'Manage one balance across APC Plus.',
        creditsCue: 'One connected balance for shopping, travel, rewards, and sharing',
        mobileKicker: 'Mobile app · Coming soon',
        mobileTitle: 'APC Plus is coming to iOS and Android.',
        mobileLead: 'Take the APC Plus experience with you. Store downloads are coming soon.',
        comingOn: 'Coming soon on the',
        comingOnShort: 'Coming soon on',
        futureKicker: 'Future horizon',
        futureTitle: 'What comes next.',
        future1: 'Prediction Markets',
        future2: 'Perpetual Trading',
        future3: 'RWA Gold & Earn',
        future4: 'AI Agent interaction',
        future5: 'Payment links & requests',
        comingSoon: 'Coming soon',
        agentsKicker: 'On the roadmap · AI Agent',
        agentsTitle: 'Ask. Review. Stay in control.',
        agentsLead:
            'A future APC Plus experience could let a connected AI assistant search vouchers, check your Credits, and prepare a checkout using your existing account.',
        agentsDisclaimer:
            'AI agent interaction is a roadmap concept. It is not available in the live APC Plus app today.',
        startLead: 'Sign in to use the current APC Plus web app, or create an account to get started.',
        startPoint1: 'Manage your Credits securely in one account.',
        startPoint2: 'Shop gift cards, vouchers, and eSIMs; book hotels and flights.',
        startPoint3: 'Earn cashback and send Red Packets.',
        continueText: 'Choose the path that fits you. Both links open the live APC Plus web app.',
        footerBlurb: 'Your Credits. More ways to use them.',
    },
    zh: {
        ...shared,
        metaTitle: 'APC Plus — 积分、奖励与下一步',
        metaDescription: '购物、赚取、发送并管理你的 Credits，尽在一处。',
        navLive: '网页应用',
        navRoadmap: '路线图',
        navMobile: '移动端',
        navFuture: '下一步',
        navStart: '开始使用',
        eyebrow: '现已上线 · 网页应用',
        titleLead: '你的积分，',
        titleAccent: '准备好做更多。',
        heroCopy: '购物、赚取、发送并管理你的 Credits，尽在一处。',
        seeNext: '看看下一步',
        heroNoteLink: '登录 APC Plus。',
        previewLabel: 'APC Plus Credits 体验示意',
        previewTag: '你的 Credits，由你做主',
        previewActions: '购物。赚取。发送。管理。',
        shop: '购物',
        earn: '赚取',
        send: '发送',
        manage: '管理',
        previewFoot: '一个账户。更多使用 Credits 的方式。',
        liveKicker: 'Credits 生态',
        liveTitle: 'Credits，服务人们每天在做的事。',
        liveLead: '购买礼品卡和代金券，连接 eSIM，预订酒店和机票，赚取返现，并发送红包。',
        utilTitle: '日常实用',
        utilText: '购买礼品卡、代金券和 eSIM。',
        travelTitle: '出行',
        travelText: '用 Credits 预订酒店和机票。',
        rewardsTitle: '奖励',
        rewardsText: '符合条件的消费可获得返现。',
        socialTitle: '社交赠礼',
        socialText: '向亲友发送红包。',
        controlTitle: '灵活掌控',
        controlText: '在 APC Plus 中管理同一余额。',
        creditsCue: '一个余额，连接购物、出行、奖励与分享',
        mobileKicker: '移动应用 · 即将推出',
        mobileTitle: 'APC Plus 即将登陆 iOS 与 Android。',
        mobileLead: '把 APC Plus 带在身边。应用商店下载即将开放。',
        comingOn: '即将上线于',
        comingOnShort: '即将上线于',
        futureKicker: '未来方向',
        futureTitle: '接下来是什么。',
        future1: '预测市场',
        future2: '永续交易',
        future3: 'RWA Gold & Earn',
        future4: 'AI Agent 互动',
        future5: '付款链接与请求',
        comingSoon: '即将推出',
        agentsKicker: '路线图 · AI Agent',
        agentsTitle: '询问。核对。始终由你掌控。',
        agentsLead: '未来的 APC Plus 体验可以让已连接的 AI 助手搜索代金券、查看你的 Credits，并用你现有的账户准备结账。',
        agentsDisclaimer: 'AI Agent 互动是路线图概念，目前尚未在 APC Plus 应用中提供。',
        startLead: '登录以使用现有的 APC Plus 网页应用，或创建账户开始使用。',
        startPoint1: '在一个账户中安全管理你的 Credits。',
        startPoint2: '购买礼品卡、代金券和 eSIM；预订酒店和机票。',
        startPoint3: '赚取返现并发送红包。',
        continueText: '选择适合你的路径。两个链接都会打开正在运行的 APC Plus 网页应用。',
        footerBlurb: '你的 Credits。更多使用方式。',
    },
    th: {
        ...shared,
        metaTitle: 'APC Plus — Credits รางวัล และสิ่งที่กำลังจะมา',
        metaDescription: 'ช้อป รับ ส่ง และจัดการ Credits ของคุณ — ทั้งหมดในที่เดียว',
        navLive: 'เว็บแอป',
        navRoadmap: 'แผนงาน',
        navMobile: 'มือถือ',
        navFuture: 'ถัดไป',
        navStart: 'เริ่มต้น',
        eyebrow: 'ใช้งานได้แล้ว · เว็บแอป',
        titleLead: 'Credits ของคุณ ',
        titleAccent: 'พร้อมไปต่อ',
        heroCopy: 'ช้อป รับ ส่ง และจัดการ Credits ของคุณ — ทั้งหมดในที่เดียว',
        seeNext: 'ดูสิ่งที่กำลังจะมา',
        heroNoteLink: 'เข้าสู่ระบบ APC Plus',
        previewLabel: 'ภาพตัวอย่างประสบการณ์ Credits ของ APC Plus',
        previewTag: 'Credits ของคุณ ในแบบของคุณ',
        previewActions: 'ช้อป รับ ส่ง จัดการ',
        shop: 'ช้อป',
        earn: 'รับ',
        send: 'ส่ง',
        manage: 'จัดการ',
        previewFoot: 'บัญชีเดียว ใช้ Credits ได้หลายทาง',
        liveKicker: 'ระบบนิเวศ Credits',
        liveTitle: 'Credits สำหรับสิ่งที่ผู้คนทำทุกวัน',
        liveLead: 'ซื้อบัตรของขวัญและบัตรกำนัล เชื่อมต่อด้วย eSIM จองโรงแรมและเที่ยวบิน รับเงินคืน และส่ง Red Packet',
        utilTitle: 'ใช้ได้ทุกวัน',
        utilText: 'ซื้อบัตรของขวัญ บัตรกำนัล และ eSIM',
        travelTitle: 'ท่องเที่ยว',
        travelText: 'จองโรงแรมและเที่ยวบินด้วย Credits',
        rewardsTitle: 'รางวัล',
        rewardsText: 'รับเงินคืนจากรายการที่เข้าเงื่อนไข',
        socialTitle: 'ของขวัญ',
        socialText: 'ส่ง Red Packet ให้เพื่อนและครอบครัว',
        controlTitle: 'ควบคุมยืดหยุ่น',
        controlText: 'จัดการยอดเดียวทั่วทั้ง APC Plus',
        creditsCue: 'ยอดเดียวที่เชื่อมช้อปปิ้ง ท่องเที่ยว รางวัล และการแชร์',
        mobileKicker: 'แอปมือถือ · เร็วๆ นี้',
        mobileTitle: 'APC Plus กำลังจะมาบน iOS และ Android',
        mobileLead: 'พาประสบการณ์ APC Plus ไปกับคุณ ดาวน์โหลดจากสโตร์เร็วๆ นี้',
        comingOn: 'เร็วๆ นี้บน',
        comingOnShort: 'เร็วๆ นี้บน',
        futureKicker: 'ขอบฟ้าถัดไป',
        futureTitle: 'สิ่งที่กำลังจะมา',
        future1: 'ตลาดพยากรณ์',
        future2: 'เทรด Perpetual',
        future3: 'RWA Gold & Earn',
        future4: 'การโต้ตอบ AI Agent',
        future5: 'ลิงก์และคำขอชำระเงิน',
        comingSoon: 'เร็วๆ นี้',
        agentsKicker: 'ในแผนงาน · AI Agent',
        agentsTitle: 'ถาม ตรวจ และควบคุมเอง',
        agentsLead:
            'ประสบการณ์ APC Plus ในอนาคตอาจให้ผู้ช่วย AI ที่เชื่อมต่อค้นหาบัตรกำนัล ตรวจ Credits และเตรียมการชำระเงินจากบัญชีที่คุณมีอยู่',
        agentsDisclaimer: 'การโต้ตอบ AI Agent เป็นแนวคิดในแผนงาน ยังไม่พร้อมใช้ในแอป APC Plus วันนี้',
        startLead: 'เข้าสู่ระบบเพื่อใช้เว็บแอป APC Plus ปัจจุบัน หรือสร้างบัญชีเพื่อเริ่มต้น',
        startPoint1: 'จัดการ Credits อย่างปลอดภัยในบัญชีเดียว',
        startPoint2: 'ซื้อบัตรของขวัญ บัตรกำนัล และ eSIM จองโรงแรมและเที่ยวบิน',
        startPoint3: 'รับเงินคืนและส่ง Red Packet',
        continueText: 'เลือกเส้นทางที่เหมาะกับคุณ ทั้งสองลิงก์เปิดเว็บแอป APC Plus ที่ใช้งานอยู่',
        footerBlurb: 'Credits ของคุณ ใช้ได้หลายทางกว่าเดิม',
    },
    vi: {
        ...shared,
        metaTitle: 'APC Plus — Credits, phần thưởng và những gì tiếp theo',
        metaDescription: 'Mua sắm, nhận thưởng, gửi và quản lý Credits — tất cả trong một nơi.',
        navLive: 'Ứng dụng web',
        navRoadmap: 'Lộ trình',
        navMobile: 'Di động',
        navFuture: 'Tiếp theo',
        navStart: 'Bắt đầu',
        eyebrow: 'Đang hoạt động · Ứng dụng web',
        titleLead: 'Credits của bạn, ',
        titleAccent: 'sẵn sàng cho nhiều hơn.',
        heroCopy: 'Mua sắm, nhận thưởng, gửi và quản lý Credits — tất cả trong một nơi.',
        seeNext: 'Xem những gì tiếp theo',
        heroNoteLink: 'Đăng nhập APC Plus.',
        previewLabel: 'Minh họa trải nghiệm Credits của APC Plus',
        previewTag: 'Credits của bạn, theo cách của bạn',
        previewActions: 'Mua. Nhận. Gửi. Quản lý.',
        shop: 'Mua',
        earn: 'Nhận',
        send: 'Gửi',
        manage: 'Quản lý',
        previewFoot: 'Một tài khoản. Nhiều cách dùng Credits hơn.',
        liveKicker: 'Hệ sinh thái Credits',
        liveTitle: 'Credits cho những việc mọi người làm mỗi ngày.',
        liveLead:
            'Mua thẻ quà và voucher, kết nối với eSIM, đặt khách sạn và vé máy bay, nhận hoàn tiền, và gửi Red Packet.',
        utilTitle: 'Tiện ích hằng ngày',
        utilText: 'Mua thẻ quà, voucher và eSIM.',
        travelTitle: 'Du lịch',
        travelText: 'Đặt khách sạn và vé máy bay bằng Credits.',
        rewardsTitle: 'Phần thưởng',
        rewardsText: 'Nhận hoàn tiền cho các giao dịch đủ điều kiện.',
        socialTitle: 'Quà tặng',
        socialText: 'Gửi Red Packet cho bạn bè và gia đình.',
        controlTitle: 'Kiểm soát linh hoạt',
        controlText: 'Quản lý một số dư trên toàn APC Plus.',
        creditsCue: 'Một số dư kết nối cho mua sắm, du lịch, phần thưởng và chia sẻ',
        mobileKicker: 'Ứng dụng di động · Sắp ra mắt',
        mobileTitle: 'APC Plus sắp có trên iOS và Android.',
        mobileLead: 'Mang trải nghiệm APC Plus theo bạn. Bản tải trên cửa hàng sắp ra mắt.',
        comingOn: 'Sắp có trên',
        comingOnShort: 'Sắp có trên',
        futureKicker: 'Tầm nhìn phía trước',
        futureTitle: 'Những gì tiếp theo.',
        future1: 'Thị trường dự đoán',
        future2: 'Giao dịch perpetual',
        future3: 'RWA Gold & Earn',
        future4: 'Tương tác AI Agent',
        future5: 'Liên kết và yêu cầu thanh toán',
        comingSoon: 'Sắp ra mắt',
        agentsKicker: 'Trên lộ trình · AI Agent',
        agentsTitle: 'Hỏi. Xem lại. Luôn kiểm soát.',
        agentsLead:
            'Trải nghiệm APC Plus trong tương lai có thể để trợ lý AI đã kết nối tìm voucher, kiểm tra Credits và chuẩn bị thanh toán bằng tài khoản hiện có của bạn.',
        agentsDisclaimer:
            'Tương tác AI Agent là khái niệm trên lộ trình. Tính năng này chưa có trong ứng dụng APC Plus hôm nay.',
        startLead: 'Đăng nhập để dùng ứng dụng web APC Plus hiện tại, hoặc tạo tài khoản để bắt đầu.',
        startPoint1: 'Quản lý Credits an toàn trong một tài khoản.',
        startPoint2: 'Mua thẻ quà, voucher và eSIM; đặt khách sạn và vé máy bay.',
        startPoint3: 'Nhận hoàn tiền và gửi Red Packet.',
        continueText: 'Chọn đường phù hợp với bạn. Cả hai liên kết đều mở ứng dụng web APC Plus đang hoạt động.',
        footerBlurb: 'Credits của bạn. Nhiều cách dùng hơn.',
    },
    ja: {
        ...shared,
        metaTitle: 'APC Plus — Credits、リワード、そして次に来ること',
        metaDescription: 'ショップ、獲得、送信、管理。Credits をひとつの場所で。',
        navLive: 'ウェブアプリ',
        navRoadmap: 'ロードマップ',
        navMobile: 'モバイル',
        navFuture: '次に来ること',
        navStart: 'はじめる',
        eyebrow: '公開中 · ウェブアプリ',
        titleLead: 'あなたの Credits、',
        titleAccent: 'もっと使える準備ができています。',
        heroCopy: 'ショップ、獲得、送信、管理。Credits をひとつの場所で。',
        seeNext: '次に来るものを見る',
        heroNoteLink: 'APC Plus にサインイン。',
        previewLabel: 'APC Plus Credits 体験のイメージ',
        previewTag: 'あなたの Credits を、あなたの方法で',
        previewActions: 'ショップ。獲得。送信。管理。',
        shop: 'ショップ',
        earn: '獲得',
        send: '送信',
        manage: '管理',
        previewFoot: 'ひとつのアカウント。Credits の使い方が広がります。',
        liveKicker: 'Credits のエコシステム',
        liveTitle: '毎日のことに使える Credits。',
        liveLead: 'ギフトカードやバウチャーの購入、eSIM 接続、ホテルと航空券の予約、キャッシュバック、Red Packet の送信。',
        utilTitle: '毎日の実用',
        utilText: 'ギフトカード、バウチャー、eSIM を購入。',
        travelTitle: 'トラベル',
        travelText: 'Credits でホテルと航空券を予約。',
        rewardsTitle: 'リワード',
        rewardsText: '対象の購入でキャッシュバックを受け取る。',
        socialTitle: 'ギフト',
        socialText: '友人や家族に Red Packet を送る。',
        controlTitle: '柔軟な管理',
        controlText: 'APC Plus 全体でひとつの残高を管理。',
        creditsCue: 'ショッピング、旅行、リワード、シェアをつなぐひとつの残高',
        mobileKicker: 'モバイルアプリ · 近日公開',
        mobileTitle: 'APC Plus が iOS と Android に登場します。',
        mobileLead: 'APC Plus を持ち歩けるように。ストアからのダウンロードは近日公開です。',
        comingOn: '近日公開',
        comingOnShort: '近日公開',
        futureKicker: 'これからの展望',
        futureTitle: '次に来ること。',
        future1: '予測市場',
        future2: 'パーペチュアル取引',
        future3: 'RWA Gold & Earn',
        future4: 'AI Agent とのやり取り',
        future5: '支払いリンクとリクエスト',
        comingSoon: '近日公開',
        agentsKicker: 'ロードマップ · AI Agent',
        agentsTitle: '頼む。確認する。自分で決める。',
        agentsLead:
            'これからの APC Plus では、接続した AI アシスタントがバウチャーを探し、Credits を確認し、既存のアカウントで決済を準備できるようになる構想です。',
        agentsDisclaimer: 'AI Agent とのやり取りはロードマップ上の構想です。現在の APC Plus アプリでは利用できません。',
        startLead: '現在の APC Plus ウェブアプリを使うにはサインインするか、アカウントを作成してはじめてください。',
        startPoint1: 'ひとつのアカウントで Credits を安全に管理。',
        startPoint2: 'ギフトカード、バウチャー、eSIM を購入。ホテルと航空券を予約。',
        startPoint3: 'キャッシュバックを受け取り、Red Packet を送る。',
        continueText: 'あなたに合う方法を選んでください。どちらのリンクも公開中の APC Plus ウェブアプリを開きます。',
        footerBlurb: 'あなたの Credits。使い方が広がります。',
    },
    ko: {
        ...shared,
        metaTitle: 'APC Plus — Credits, 리워드, 그리고 다음 단계',
        metaDescription: '쇼핑, 적립, 전송, 관리. Credits를 한곳에서.',
        navLive: '웹 앱',
        navRoadmap: '로드맵',
        navMobile: '모바일',
        navFuture: '다음 단계',
        navStart: '시작하기',
        eyebrow: '이용 가능 · 웹 앱',
        titleLead: '당신의 Credits, ',
        titleAccent: '더 많은 준비가 되었습니다.',
        heroCopy: '쇼핑, 적립, 전송, 관리. Credits를 한곳에서.',
        seeNext: '다음 단계 보기',
        heroNoteLink: 'APC Plus에 로그인.',
        previewLabel: 'APC Plus Credits 경험 예시',
        previewTag: '당신의 Credits, 당신의 방식',
        previewActions: '쇼핑. 적립. 전송. 관리.',
        shop: '쇼핑',
        earn: '적립',
        send: '전송',
        manage: '관리',
        previewFoot: '하나의 계정. Credits를 더 다양하게.',
        liveKicker: 'Credits 생태계',
        liveTitle: '사람들이 매일 하는 일을 위한 Credits.',
        liveLead: '기프트 카드와 바우처를 사고, eSIM으로 연결하고, 호텔과 항공권을 예약하고, 캐시백을 받고, Red Packet을 보내세요.',
        utilTitle: '일상 활용',
        utilText: '기프트 카드, 바우처, eSIM을 구매하세요.',
        travelTitle: '여행',
        travelText: 'Credits로 호텔과 항공권을 예약하세요.',
        rewardsTitle: '리워드',
        rewardsText: '해당 구매에서 캐시백을 받으세요.',
        socialTitle: '선물',
        socialText: '친구와 가족에게 Red Packet을 보내세요.',
        controlTitle: '유연한 관리',
        controlText: 'APC Plus 전체에서 하나의 잔액을 관리하세요.',
        creditsCue: '쇼핑, 여행, 리워드, 나눔을 잇는 하나의 잔액',
        mobileKicker: '모바일 앱 · 곧 출시',
        mobileTitle: 'APC Plus가 iOS와 Android에 찾아옵니다.',
        mobileLead: 'APC Plus를 함께 가져가세요. 스토어 다운로드가 곧 열립니다.',
        comingOn: '곧 출시',
        comingOnShort: '곧 출시',
        futureKicker: '앞으로의 지평',
        futureTitle: '다음에 올 것.',
        future1: '예측 시장',
        future2: '무기한 거래',
        future3: 'RWA Gold & Earn',
        future4: 'AI Agent 상호작용',
        future5: '결제 링크와 요청',
        comingSoon: '곧 출시',
        agentsKicker: '로드맵 · AI Agent',
        agentsTitle: '요청하고. 확인하고. 직접 결정하세요.',
        agentsLead:
            '앞으로의 APC Plus는 연결된 AI 어시스턴트가 바우처를 찾고, Credits를 확인하며, 기존 계정으로 결제를 준비하게 할 수 있습니다.',
        agentsDisclaimer: 'AI Agent 상호작용은 로드맵 개념입니다. 현재 APC Plus 앱에서는 이용할 수 없습니다.',
        startLead: '현재 APC Plus 웹 앱을 쓰려면 로그인하거나, 계정을 만들어 시작하세요.',
        startPoint1: '하나의 계정에서 Credits를 안전하게 관리하세요.',
        startPoint2: '기프트 카드, 바우처, eSIM을 구매하고 호텔과 항공권을 예약하세요.',
        startPoint3: '캐시백을 받고 Red Packet을 보내세요.',
        continueText: '맞는 경로를 고르세요. 두 링크 모두 현재 이용 중인 APC Plus 웹 앱을 엽니다.',
        footerBlurb: '당신의 Credits. 더 많은 사용 방법.',
    },
    id: {
        ...shared,
        metaTitle: 'APC Plus — Credits, reward, dan yang berikutnya',
        metaDescription: 'Belanja, dapatkan, kirim, dan kelola Credits Anda — semuanya di satu tempat.',
        navLive: 'Aplikasi web',
        navRoadmap: 'Peta jalan',
        navMobile: 'Seluler',
        navFuture: 'Berikutnya',
        navStart: 'Mulai',
        eyebrow: 'Sudah live · Aplikasi web',
        titleLead: 'Credits Anda, ',
        titleAccent: 'siap untuk lebih banyak.',
        heroCopy: 'Belanja, dapatkan, kirim, dan kelola Credits Anda — semuanya di satu tempat.',
        seeNext: 'Lihat yang berikutnya',
        heroNoteLink: 'Masuk ke APC Plus.',
        previewLabel: 'Ilustrasi pengalaman Credits APC Plus',
        previewTag: 'Credits Anda, dengan cara Anda',
        previewActions: 'Belanja. Dapatkan. Kirim. Kelola.',
        shop: 'Belanja',
        earn: 'Dapatkan',
        send: 'Kirim',
        manage: 'Kelola',
        previewFoot: 'Satu akun. Lebih banyak cara memakai Credits.',
        liveKicker: 'Ekosistem Credits',
        liveTitle: 'Credits untuk hal yang orang lakukan setiap hari.',
        liveLead:
            'Beli gift card dan voucher, terhubung dengan eSIM, pesan hotel dan penerbangan, dapatkan cashback, dan kirim Red Packet.',
        utilTitle: 'Kebutuhan harian',
        utilText: 'Beli gift card, voucher, dan eSIM.',
        travelTitle: 'Perjalanan',
        travelText: 'Pesan hotel dan penerbangan dengan Credits.',
        rewardsTitle: 'Reward',
        rewardsText: 'Terima cashback untuk pembelian yang memenuhi syarat.',
        socialTitle: 'Hadiah',
        socialText: 'Kirim Red Packet ke teman dan keluarga.',
        controlTitle: 'Kontrol fleksibel',
        controlText: 'Kelola satu saldo di seluruh APC Plus.',
        creditsCue: 'Satu saldo terhubung untuk belanja, perjalanan, reward, dan berbagi',
        mobileKicker: 'Aplikasi seluler · Segera hadir',
        mobileTitle: 'APC Plus akan hadir di iOS dan Android.',
        mobileLead: 'Bawa pengalaman APC Plus bersama Anda. Unduhan toko segera hadir.',
        comingOn: 'Segera hadir di',
        comingOnShort: 'Segera hadir di',
        futureKicker: 'Cakrawala berikutnya',
        futureTitle: 'Yang akan datang.',
        future1: 'Pasar prediksi',
        future2: 'Perdagangan perpetual',
        future3: 'RWA Gold & Earn',
        future4: 'Interaksi AI Agent',
        future5: 'Tautan dan permintaan pembayaran',
        comingSoon: 'Segera hadir',
        agentsKicker: 'Di peta jalan · AI Agent',
        agentsTitle: 'Minta. Tinjau. Tetap kendalikan.',
        agentsLead:
            'Pengalaman APC Plus di masa depan dapat membiarkan asisten AI yang terhubung mencari voucher, memeriksa Credits, dan menyiapkan checkout dengan akun yang sudah Anda miliki.',
        agentsDisclaimer:
            'Interaksi AI Agent adalah konsep peta jalan. Fitur ini belum tersedia di aplikasi APC Plus hari ini.',
        startLead: 'Masuk untuk memakai aplikasi web APC Plus saat ini, atau buat akun untuk memulai.',
        startPoint1: 'Kelola Credits dengan aman dalam satu akun.',
        startPoint2: 'Beli gift card, voucher, dan eSIM; pesan hotel dan penerbangan.',
        startPoint3: 'Dapatkan cashback dan kirim Red Packet.',
        continueText: 'Pilih jalur yang cocok. Kedua tautan membuka aplikasi web APC Plus yang sedang berjalan.',
        footerBlurb: 'Credits Anda. Lebih banyak cara memakainya.',
    },
};
